(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initFooter() {
    document.querySelectorAll('.krug-footer-directory').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const mobile = window.matchMedia('(max-width:760px)'), groups = Array.from(nav.querySelectorAll('details'));
      function sync() { groups.forEach(group => { group.open = !mobile.matches; }); }
      groups.forEach(group => group.addEventListener('toggle', () => { if (!mobile.matches && !group.open) group.open = true; }));
      mobile.addEventListener('change',sync); sync();
    });
  }
  document.addEventListener('click',event=>{document.querySelectorAll('.krug-country[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.krug-country[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  initFooter(); document.addEventListener('shopify:section:load',initFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krug-bestellschein"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bs').forEach(root=>{
const form=root.querySelector('form'), rows=root.querySelector('.bs-rows'); if(!form||!rows)return;
const format=new Intl.NumberFormat('de-AT',{style:'currency',currency:'EUR'});
function refresh(){let total=0,unknown=false; rows.querySelectorAll('.bs-row').forEach((row,index)=>{row.querySelector('legend').textContent='Position '+(index+1);const fields=['Bezeichnung','Artikelnummer','Stückzahl','Einzelpreis EUR'];row.querySelectorAll('input').forEach((input,j)=>input.name='contact[Position '+(index+1)+' '+fields[j]+']');const title=row.querySelector('[data-field="title"]');title.required=false;row.querySelector('.bs-remove').disabled=rows.children.length===1;if(title.value.trim()){const price=row.querySelector('[data-field="price"]').value;if(price==='')unknown=true;else total+=Math.round(Number(price)*100)*Number(row.querySelector('[data-field="qty"]').value)/100;}});root.querySelector('.bs-total').textContent='Summe der angegebenen Preise: '+format.format(total)+(unknown?' · weitere Preise offen':'');}
rows.addEventListener('input',refresh);rows.addEventListener('click',e=>{if(e.target.closest('.bs-remove')&&rows.children.length>1){e.target.closest('.bs-row').remove();refresh();}});
root.querySelector('.bs-add').addEventListener('click',()=>{if(rows.children.length>=100)return;const row=rows.firstElementChild.cloneNode(true);row.querySelectorAll('input').forEach(input=>{input.value=input.dataset.field==='qty'?'1':'';});rows.append(row);refresh();row.querySelector('input').focus();});
form.addEventListener('submit',e=>{const filled=[...rows.children].filter(row=>row.querySelector('[data-field="title"]').value.trim());if(!filled.length){e.preventDefault();const input=rows.querySelector('[data-field="title"]');input.setCustomValidity('Bitte trage mindestens einen Wunschartikel ein.');input.reportValidity();input.addEventListener('input',()=>input.setCustomValidity(''),{once:true});return;}const partial=[...rows.children].find(row=>!row.querySelector('[data-field="title"]').value.trim()&&(row.querySelector('[data-field="sku"]').value.trim()||row.querySelector('[data-field="price"]').value));if(partial){e.preventDefault();const input=partial.querySelector('[data-field="title"]');input.setCustomValidity('Bitte ergänze die Bezeichnung dieser Position.');input.reportValidity();input.addEventListener('input',()=>input.setCustomValidity(''),{once:true});return;}const lines=filled.map((row,i)=>{const v=[...row.querySelectorAll('input')].map(input=>input.value);return(i+1)+'. '+v[0]+' | Artikelnummer: '+(v[1]||'nicht angegeben')+' | Stückzahl: '+v[2]+' | Einzelpreis EUR: '+(v[3]||'offen');});form.querySelector('[name="contact[body]"]').value='ANGEBOTSANFRAGE-SHOPIFY\nBestellschein – unverbindliche Angebotsanfrage\n\n'+lines.join('\n')+'\n\nGutschein/Coupon: '+(form.querySelector('[name="contact[Gutschein oder Couponcode]"]').value||'keiner')+'\nAGB akzeptiert: Ja\nDatenschutz zur Kenntnis genommen: Ja';[...rows.children].filter(row=>!filled.includes(row)).forEach(row=>row.querySelectorAll('input').forEach(input=>input.disabled=true));});refresh();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krug-coupon"] && !Shopify.designMode) return;
  try {
    
function initKrugCoupon(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const form=root.querySelector('form');
  if(!form)return;
  const messages=JSON.parse(root.querySelector('[data-coupon-messages]').textContent);
  const campaigns=JSON.parse(root.querySelector('[data-coupon-campaigns]').textContent);
  const gate=root.querySelector('.kc-gate');
  const rewards=root.querySelector('.kc-rewards');
  const status=root.querySelector('.kc-status');
  const error=root.querySelector('.kc-error');
  const input=form.querySelector('input');
  const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
  let campaign=null;
  const voucher=root.querySelector('.kc-voucher');
  const peel=root.querySelector('[data-reveal]');
  const secret=root.querySelector('.kc-secret');
  const giftActions=root.querySelector('.kc-gift-actions');
  let peelTimer;
  const resetVoucher=()=>{clearTimeout(peelTimer);voucher.dataset.revealed='false';secret.hidden=true;peel.hidden=false;peel.disabled=false;giftActions.hidden=true;};
  peel.addEventListener('click',()=>{
    if(!campaign)return;
    voucher.dataset.revealed='true';secret.hidden=false;peel.disabled=true;giftActions.hidden=false;
    const finish=()=>{peel.hidden=true;root.querySelector('[data-copy="gift"]').focus();};
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)finish();else peelTimer=setTimeout(finish,650);
  });
  const cartNotice=()=>{
    status.textContent=messages.cart+' ';
    const link=document.createElement('a');link.href=base+'cart';link.textContent=messages.cart_link;status.append(link);
  };
  const giftCart=cart=>cart.item_count===1&&cart.items.length===1&&String(cart.items[0].variant_id)===root.dataset.variant&&cart.items[0].quantity===1;
  form.addEventListener('submit',event=>{
    event.preventDefault();error.textContent='';input.removeAttribute('aria-invalid');
    const access=input.value.trim().toLowerCase();
    campaign=campaigns.find(c=>c.access&&c.access===access)||null;
    if(!campaign){error.textContent=messages.invalid;input.setAttribute('aria-invalid','true');input.focus();return;}
    resetVoucher();
    root.querySelector('[data-code="gift"]').textContent=campaign.gift;
    root.querySelector('[data-code="tupper"]').textContent=campaign.tupper;
    root.querySelector('[data-action="tupper"]').href=base+'discount/'+encodeURIComponent(campaign.tupper)+'?redirect='+encodeURIComponent(base+'collections/tupperware-1');
    gate.hidden=true;rewards.hidden=false;rewards.querySelector('h2').focus();
  });
  root.querySelectorAll('[data-copy]').forEach(button=>button.addEventListener('click',async()=>{
    if(!campaign)return;
    try{await navigator.clipboard.writeText(campaign[button.dataset.copy]);status.textContent=messages.copied;}catch(e){status.textContent=messages.copy_failed;}
  }));
  root.querySelector('[data-action="gift"]').addEventListener('click',async event=>{
    if(!campaign)return;
    const button=event.currentTarget;button.disabled=true;status.textContent=messages.busy;
    try{
      const response=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('cart');
      let cart=await response.json();
      if(cart.item_count!==0&&!giftCart(cart)){cartNotice();return;}
      if(cart.item_count===0){
        const added=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(root.dataset.variant),quantity:1}]})});
        if(!added.ok)throw new Error('add');
      }
      const check=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!check.ok)throw new Error('cart');
      cart=await check.json();
      if(!giftCart(cart)){cartNotice();return;}
      window.location.assign(base+'discount/'+encodeURIComponent(campaign.gift)+'?redirect='+encodeURIComponent(base+'checkout'));
    }catch(e){status.textContent=messages.error;}finally{button.disabled=false;}
  });
  root.querySelector('.kc-reset').addEventListener('click',()=>{resetVoucher();campaign=null;rewards.hidden=true;gate.hidden=false;status.textContent='';form.reset();input.focus();});
}
document.querySelectorAll('[data-krug-coupon]').forEach(initKrugCoupon);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-krug-coupon]').forEach(initKrugCoupon));

  } catch(e) { console.error(e); }
})();
})();
